import React from 'react'
import { Navigate } from 'react-router'
import { AppRoutes } from '@core/AppRoutes'
import { useFeature } from '@core/Utils/hooks'
import { FeatureFlags } from '@mobi/settings/featureFlags'
import { getKambiSportsOfferingIntegrationOverrideSetting } from '@core/Areas/Settings/Store/selectors'
import { useSelector } from 'react-redux'

const SportsOfferingLazyRoute = React.lazy(() => import('./Components/MainSportsOffering'))

export const SportOfferingRoot: React.FC = () => {
  const isKambiSportsOfferingFeatureActive = useFeature(
    FeatureFlags.KAMBI_SPORTS_OFFERING_INTEGRATION.key
  )
  const isLocallyEnabled = useSelector(getKambiSportsOfferingIntegrationOverrideSetting)

  const isKambiSportsOfferingEnabled = isKambiSportsOfferingFeatureActive && isLocallyEnabled

  if (!isKambiSportsOfferingEnabled) {
    return <Navigate to={AppRoutes.SportsRoot} />
  }
  return (
    <React.Suspense fallback={null}>
      <SportsOfferingLazyRoute />
    </React.Suspense>
  )
}
